import { createContext, useContext } from 'react';
import { SizeGuideState } from './SizeGuideState';

/**
 * This context houses state used by the Mobile Size Guide Page.
 */

const SizeGuideContext = createContext<[SizeGuideState]>([
  {} as unknown as SizeGuideState,
]);

const useSizeGuideContext = () => useContext(SizeGuideContext);

export { useSizeGuideContext };

export default SizeGuideContext;
